import { css, html, LitElement } from 'lit';

class ContextMenu extends LitElement {
  static properties = {
    x: { type: Number },
    y: { type: Number },
    isOpen: { type: Boolean },
    menuItems: { type: Array }
  };

  static styles = css`
    .context-menu {
      position: fixed;
      background: white;
      border: 1px solid #ccc;
      border-radius: 4px;
      box-shadow: 0 2px 5px rgba(0,0,0,0.2);
      padding: 8px 0;
      min-width: 150px;
      z-index: 1000;
    }

    .menu-item {
      padding: 8px 16px;
      cursor: pointer;
      display: flex;
      align-items: center;
      gap: 8px;
      color: #333;
      transition: background-color 0.2s;
    }

    .menu-item:hover {
      background-color: #f5f5f5;
    }

    .menu-item.danger {
      color: #dc3545;
    }

    .menu-item.danger:hover {
      background-color: #fff5f5;
    }
  }
  `;

  constructor() {
    super();
    this.x = 0;
    this.y = 0;
    this.isOpen = false;
    this.menuItems = [];
    this._handleClickOutside = this._handleClickOutside.bind(this);
  }

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener('click', this._handleClickOutside);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener('click', this._handleClickOutside);
  }

  _handleClickOutside(e) {
    if (this.isOpen && !this.renderRoot.contains(e.target)) {
      this.close();
    }
  }

  close() {
    this.isOpen = false;
    this.dispatchEvent(new CustomEvent('menu-closed'));
  }

  handleItemClick(item) {
    this.dispatchEvent(new CustomEvent('menu-item-selected', {
      detail: item,
      bubbles: true,
      composed: true
    }));
    this.close();
  }

  render() {
    if (!this.isOpen) return null;

    return html`
      <div 
        class="context-menu" 
        style="left: ${this.x}px; top: ${this.y}px;"
        @click=${(e) => e.stopPropagation()}
      >
        ${this.menuItems.map(item => html`
          <div 
            class="menu-item ${item.type || ''}"
            @click=${() => this.handleItemClick(item)}
          >
            ${item.icon ? html`<span class="icon">${item.icon}</span>` : ''}
            ${item.label}
          </div>
        `)}
      </div>
    `;
  }
}

customElements.define('context-menu', ContextMenu);